import axios from "axios";
import React, {
  useMemo,
  useState,
  useRef,
  useCallback,
  useEffect,
} from "react";
import Papa from "papaparse";
import {
  GET_SUGGESTED_LLM_COMPETOTORS,
  LLM_PROJECT_POST,
  LLM_UPDATE_KEYWORD,
  POST_SUGGESTED_LLM_COMPETOTORS,
} from "../../../../../services/constants";
import Alert from "@mui/material/Alert";
import Spinner from "../../spinner";
import AddProjectStore from "../../../../../store/AddProjectStore";

import { Box, Flex } from "@semcore/ui/flex-box";
import { Text } from "@semcore/typography";

import AddKeywordTag from "./AddKeywordTag";
import SemButton from "../../../../../common/components/Button";
import { ZustandStore } from "../../../../../store/zustand-store";
import { useTranslation } from "react-i18next";
import { useTableBlur } from "../../../custom-hook/useTableBlur";
import { LLMTrackerStore } from "../../../../../store/LLMTrackerStore";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const AddKeyword = () => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const ALLLocationCode = useRef([]);
  const admin_mail = localStorage.getItem("admin_mail");

  const {
    addProject,
    setAddProjectField,
    resetAddProject,
    showNotification,
    setModalVisibility,
  } = AddProjectStore((state) => state);
  const customer_plan = ZustandStore((state) => state.customer_plan);
  const SELECTED_PROJECT = LLMTrackerStore((state) => state.SELECTED_PROJECT);
  const userKeywordlimit = customer_plan?.llm_keyword || 0;
  const website_domain = SELECTED_PROJECT?.weburl || null;

  const loading = addProject.project_usage.loading;
  const error = addProject.project_usage.error;
  const accUsage = addProject.project_usage.limits;
  const totalKeywordTracking = accUsage?.total_llm_keyword_tracking || 0;
  const maxAllowedKeywordForFreeTrialUser = 5; // for trial users
  const shouldTableBlur = useTableBlur({
    currentPage: 0,
    blurFromPage: 1,
  });
  const [item, setItem] = useState([]);
  const [KeywordStatus, setKeywordStatus] = useState({
    isLoading: false,
    isError: null,
    isSuccess: false,
  });
  const [errors, setErrors] = useState({ type: "", message: "", show: false });
  const [PromptSuggestionList, setPromptSuggestionList] = useState({
    loading: true,
    data: [],
    error: null,
  });

  const handleGetUserSuggestedCompetitors = async () => {
    try {
      const resp = await axios.get(
        GET_SUGGESTED_LLM_COMPETOTORS(addProject?.domainUrl)
      );
      if (resp.data && resp.data.length > 0) {
        setPromptSuggestionList({
          loading: false,
          data: resp.data || [],
          error: null,
        });
      } else {
        const response = await axios.post(POST_SUGGESTED_LLM_COMPETOTORS(), {
          domain: addProject?.domainUrl,
        });
        setPromptSuggestionList({
          loading: false,
          data: response?.data || [],
          error: null,
        });
      }
    } catch (error) {
      setPromptSuggestionList({
        loading: false,
        data: [],
        error: error.message,
      });
    }
  };

  useEffect(() => {
    if (!addProject?.domainUrl) return;

    const timeout = setTimeout(() => {
      handleGetUserSuggestedCompetitors();
    }, 500);

    return () => clearTimeout(timeout);
  }, [addProject?.domainUrl]);

  const arrayFinal = useMemo(() => {
    const cleanedLower = item
      ?.filter((str) => typeof str === "string")
      .map((str) => str.trim())
      .filter(Boolean);

    return [...new Set(cleanedLower)];
  }, [item]);

  var curr_keyword = arrayFinal?.length;
  var total_keyword = curr_keyword + Number(totalKeywordTracking);

  const handleUserProjectUpdate = () => {
    LLMTrackerStore.setState(() => ({
      ISPROJECT: true,
      KEYWORD_LOC_DATA: "",
      KEYWORD_ALL_LOC_DATA: [],
      KEYWORD_LATEST_DATA: [],
      KEYWORD_OLD_DATA: [],
      USER_LLM_PROJECT: [],
      SELECTED_PROJECT: null,
    }));
    if (addProject.type === "Add-Project") {
      resetAddProject();
      setModalVisibility(true);
    } else {
      resetAddProject();
    }
  };

  const keywordCount = useMemo(() => {
    return (
      arrayFinal.length * (addProject?.location?.length || 0) +
      Number(totalKeywordTracking || 0)
    );
  }, [arrayFinal, addProject?.location, totalKeywordTracking]);

  // on submit data send to the rest api
  const getproject = async () => {
    if (arrayFinal.length === 0) {
      setErrors({
        type: "error",
        message: "Please add at least one prompt to proceed with the project",
        show: true,
      });
      return;
    }
    if (
      arrayFinal.length * addProject?.location?.length +
        Number(totalKeywordTracking) >
      Number(userKeywordlimit)
    ) {
      setErrors({
        type: "error",
        message:
          "You have reached your maximum limit of " +
          userKeywordlimit +
          "prompts",
        show: true,
      });
      return;
    }

    if (
      shouldTableBlur?.isTrialUser &&
      keywordCount > maxAllowedKeywordForFreeTrialUser
    ) {
      setErrors({
        type: "error",
        message: "",
        show: false,
      });
      return;
    }
    if (
      website_domain !== null &&
      addProject.domainUrl === website_domain &&
      addProject.project_id
    ) {
      setKeywordStatus({
        isLoading: true,
        isError: false,
        isSuccess: false,
      });

      addProject?.location?.filter((loca) => {
        return ALLLocationCode.current.push(loca.location_code);
      });

      const locations = JSON.stringify(ALLLocationCode.current);
      const updatekeyword_Json = {
        id: SELECTED_PROJECT.id,
        location: locations,
        language_code: addProject?.language?.language_name,
      };
      axios
        .put(LLM_UPDATE_KEYWORD(updatekeyword_Json), {
          key: arrayFinal,
        })
        .then(() => {
          showNotification({
            message: "Prompts added successfully 🎉",
            severity: "success",
          });
          handleUserProjectUpdate();
        })
        .catch(() => {
          showNotification({
            message: "Unexpected error occurred 🤷‍♂️",
            severity: "error",
          });
          setKeywordStatus({
            isLoading: false,
            isError: true,
            isSuccess: false,
          });
        });
    } else {
      setKeywordStatus({
        isLoading: true,
        isError: false,
        isSuccess: false,
      });

      const data = addProject?.location?.map((loca) => {
        return {
          email: admin_mail,
          weburl: addProject.domainUrl,
          language_code: addProject?.language?.language_name,
          location_name: loca.location_name,
          location_code: loca.location_code,
          keyword: arrayFinal,
          competitors: addProject?.competitors || [],
          brand: addProject?.brand_name || [],
          llm: addProject?.llm_tracker || [],
        };
      });

      const dataHandler = {
        keyword: data.flat(),
      };
      axios
        .post(LLM_PROJECT_POST(), dataHandler)
        .then(() => {
          showNotification({
            message: "Project added successfully 🎉",
            severity: "success",
          });
          handleUserProjectUpdate();
        })
        .catch(() => {
          showNotification({
            message: "Unexpected error occurred 🤷‍♂️",
            severity: "error",
          });
          setKeywordStatus({
            isLoading: false,
            isError: true,
            isSuccess: false,
          });
        });
    }
  };

  const downloadCSV = () => {
    const SampleCSV = [
      { keyword: "free seo tool" },
      { keyword: "backlink checker" },
      { keyword: "rank tracking tool" },
    ];

    const csv = Papa.unparse(SampleCSV);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    // Create a link to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "prompt_sample.csv");
    // Append to the document to trigger the click event
    document.body.appendChild(link);
    link.click();
    // Clean up and remove the link
    document.body.removeChild(link);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      complete: (results) => {
        const keywordSet = results?.data;
        if (keywordSet && Array.isArray(keywordSet)) {
          const newKeywords = keywordSet
            .map((res) => res.keyword || res.Keyword)
            .filter(Boolean); // Filter out undefined or falsy values

          setItem((oldItems) => [...oldItems, ...newKeywords]);
        }
        // Reset the file input value
        fileInputRef.current.value = "";
      },
    });
  };

  const handleStepChange = (newStep) => {
    setAddProjectField("step", newStep);
  };

  const handleInputAddKeyword = useCallback(
    (input) => {
      let keywordsToToggle = Array.isArray(input) ? input : [input];
      keywordsToToggle = keywordsToToggle
        .map((kw) => kw.trim())
        .filter(Boolean);

      // Remove internal duplicates (case-insensitive)
      const normalizedInputSet = new Set();
      keywordsToToggle = keywordsToToggle.filter((kw) => {
        const lower = kw.toLowerCase();
        if (normalizedInputSet.has(lower)) return false;
        normalizedInputSet.add(lower);
        return true;
      });

      if (!keywordsToToggle.length) {
        return setErrors({
          type: "error",
          message: "No new prompts to add",
          show: true,
        });
      }

      setItem((prevTags) => {
        const keywordLimit = Number(userKeywordlimit);
        const existingLowerSet = new Set(prevTags.map((k) => k.toLowerCase()));

        // Split prompts into: ones to add, and ones to remove
        const toAdd = [];
        const toRemoveSet = new Set();

        keywordsToToggle.forEach((kw) => {
          const lower = kw.toLowerCase();
          if (existingLowerSet.has(lower)) {
            toRemoveSet.add(lower); // toggle off
          } else {
            toAdd.push(kw); // toggle on
          }
        });

        // Remove existing prompts that match
        const updatedTags = prevTags.filter(
          (tag) => !toRemoveSet.has(tag.toLowerCase())
        );

        // Check keyword limit before adding
        if (total_keyword - toRemoveSet.size + toAdd.length > keywordLimit) {
          setErrors({
            type: "error",
            message: `You have reached your maximum limit of ${userKeywordlimit} prompts`,
            show: true,
          });
          return prevTags;
        }

        if (errors?.show) {
          setErrors({ type: "", message: "", show: false });
        }

        return [...updatedTags, ...toAdd];
      });
    },
    [userKeywordlimit, errors?.show, total_keyword]
  );

  return (
    <Box style={{ padding: "0 3px" }}>
      {error ? (
        <div style={{ height: "400px" }}>
          <p className="text-center msg-error">{t("add_keyword.error")}</p>
        </div>
      ) : loading ? (
        <div style={{ height: "400px" }}>
          <Spinner />
        </div>
      ) : (
        <div className="">
          <Flex direction="column">
            <Flex flexWrap="wrap" gap={2} mt={3}>
              <Text>
                Prompts{" "}
                <span className="importCsv font-bold">
                  ( {t("add_keyword.paste_or")}{" "}
                  <label
                    htmlFor="file-input"
                    style={{
                      color: "#365486",
                      textDecoration: "none",
                    }}
                  >
                    {t("add_keyword.import_csv")}{" "}
                  </label>{" "}
                  /
                  <span
                    className="importCsv font-bold point"
                    onClick={() => downloadCSV()}
                  >
                    {" "}
                    {t("add_keyword.sample_csv")})
                  </span>
                </span>
              </Text>
              <Text ml={"auto"}>
                Tracked Prompts: {total_keyword}/{userKeywordlimit}
              </Text>
              <div className="d-none">
                <input
                  id="file-input"
                  name="file-input"
                  type="file"
                  accept=".csv"
                  ref={fileInputRef}
                  placeholder="dfd"
                  onChange={handleFileUpload}
                />
              </div>
            </Flex>

            <AddKeywordTag
              {...{
                item,
                setItem,
                handleInputAddKeyword,
              }}
            />
            <Flex direction="column" mt={3}>
              <Text mb={1}>Suggested Prompts</Text>
              <Box className="add-pr-url w-100">
                <div
                  className="SuggestionBox px-3 py-1 text-bold list-scroll"
                  style={{ height: "300px", justifyContent: "flex-start" }}
                >
                  {PromptSuggestionList.loading ? (
                    <div className="d-flex justify-content-center align-items-center w-100 h-100">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden"></span>
                      </div>
                    </div>
                  ) : PromptSuggestionList?.data?.length != 0 ? (
                    <FormGroup>
                      {PromptSuggestionList?.data?.map((propmt) => (
                        <FormControlLabel
                          key={propmt}
                          control={
                            <Checkbox
                              onChange={() => handleInputAddKeyword(propmt)}
                              checked={arrayFinal?.includes(propmt)}
                              size="small"
                              sx={{
                                padding: "0.1rem",
                                "&.Mui-checked": {
                                  color: "#365486",
                                },
                              }}
                            />
                          }
                          label={propmt}
                          sx={{
                            alignItems: "flex-start",
                            padding: "5px 2px",
                          }}
                        />
                      ))}
                    </FormGroup>
                  ) : (
                    <div
                      className="d-flex justify-content-center align-items-center "
                      style={{ height: "160px" }}
                    >
                      <h5 className="heading-small font-bold mb-0">
                        No Suggested Prompts
                      </h5>
                    </div>
                  )}
                </div>
              </Box>
            </Flex>

            {errors.show && (
              <Text
                color={errors.type === "error" ? "red-500" : "green-500"}
                mt={1}
              >
                {errors.message}
              </Text>
            )}
            {KeywordStatus.isError && (
              <Text color={"red-500"} mt={1}>
                {t("add_keyword.opp_alert")}
              </Text>
            )}
            {KeywordStatus.isSuccess && (
              <Text color={"green-500"} mt={1}>
                {KeywordStatus.isSuccess}
              </Text>
            )}
            {shouldTableBlur?.isTrialUser &&
              keywordCount > maxAllowedKeywordForFreeTrialUser && (
                <Alert severity="error" className="mt-3">
                  <Text size={300} fontWeight={400}>
                    <>
                      You are on Free Trial now.{" "}
                      <a
                        href={`https://billing.stripe.com/p/login/14k7us0IvchS8so6oo?prefilled_email=${admin_mail}`}
                        className="anchor"
                        target="_blank"
                        style={{ color: "#6a3be4" }}
                      >
                        Pay now
                      </a>{" "}
                      to unlock all features and maximize your experience!
                    </>
                  </Text>
                </Alert>
              )}
          </Flex>
          <Flex mt={4} flexWrap gap={3}>
            <SemButton
              name="Back"
              disabled={
                KeywordStatus.isLoading ||
                KeywordStatus.isSuccess ||
                addProject.project_id
              }
              size="m"
              onClick={() => handleStepChange(2)}
              ml={"auto"}
            />

            <SemButton
              size="m"
              name={`Submit`}
              disabled={
                KeywordStatus.isLoading ||
                KeywordStatus.isSuccess ||
                (shouldTableBlur?.isTrialUser &&
                  keywordCount > maxAllowedKeywordForFreeTrialUser)
              }
              onClick={getproject}
              loading={KeywordStatus.isLoading}
            />
          </Flex>
        </div>
      )}
    </Box>
  );
};

export default AddKeyword;
